module.exports = __webpack_public_path__ + "img/placas.9cc9f782.png";